import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Lessons from "./components/Lessons";
import LessonDetail from "./components/LessonDetail";
import LessonEdit from "./components/LessonEdit";
import LessonTest from "./components/LessonTest";
import QuickSearch from "./components/QuickSearch";

// Pages
import Home from "./pages/Home";
import LessonCreator from "./components/LessonCreator";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2196f3",
    },
    secondary: {
      main: "#f50057",
    },
    background: {
      default: "#f5f5f5",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create" element={<LessonCreator />} />
          <Route path="/lesson/:id" element={<LessonDetail />} />
          <Route path="/lesson/:id/edit" element={<LessonEdit />} />
          <Route path="/lesson/:id/test" element={<LessonTest />} />
        </Routes>
        <QuickSearch />
      </Router>
    </ThemeProvider>
  );
}

export default App;
